/**
 * @generated SignedSource<<9e5ac833dddf132f7e2cac9939df8908>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UpdateStateFilter = "ACTIVE" | "AT_RISK" | "CANCELLED" | "DONE" | "NO_UPDATE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING";
export type ProjectUpdatesViewQuery$variables = {
  completedProjectsTqlQuery: string;
  endDate?: string | null;
  isNavRefreshEnabled: boolean;
  newProjectsTqlQuery: string;
  ownProjectsTqlQuery: string;
  prevDate?: string | null;
  startDate?: string | null;
  stateFilter?: UpdateStateFilter | null;
  workspaceId?: string | null;
  workspaceUUID: string;
};
export type ProjectUpdatesViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProjectUpdatesMainColumn" | "ProjectUpdatesSideColumn">;
};
export type ProjectUpdatesViewQuery = {
  response: ProjectUpdatesViewQuery$data;
  variables: ProjectUpdatesViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "completedProjectsTqlQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNavRefreshEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newProjectsTqlQuery"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownProjectsTqlQuery"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "prevDate"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stateFilter"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUUID"
},
v10 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v11 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v12 = {
  "kind": "Variable",
  "name": "stateFilter",
  "variableName": "stateFilter"
},
v13 = {
  "kind": "Variable",
  "name": "workspaceId",
  "variableName": "workspaceId"
},
v14 = {
  "kind": "Variable",
  "name": "workspaceUUID",
  "variableName": "workspaceUUID"
},
v15 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUUID"
},
v16 = {
  "kind": "ScalarField",
  "name": "count"
},
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = {
  "kind": "Variable",
  "name": "createdAfter",
  "variableName": "startDate"
},
v19 = {
  "kind": "Variable",
  "name": "createdBefore",
  "variableName": "endDate"
},
v20 = [
  (v18/*: any*/),
  (v19/*: any*/),
  {
    "kind": "Literal",
    "name": "stateFilter",
    "value": "ACTIVE"
  },
  (v14/*: any*/)
],
v21 = [
  (v18/*: any*/),
  (v19/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v12/*: any*/),
  (v13/*: any*/)
],
v22 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v23 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v24 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v25 = {
  "kind": "ScalarField",
  "name": "picture"
},
v26 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v27 = {
  "kind": "ScalarField",
  "name": "name"
},
v28 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v29 = {
  "kind": "ScalarField",
  "name": "ari"
},
v30 = {
  "kind": "ScalarField",
  "name": "private"
},
v31 = {
  "concreteType": "IconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThemeURIs",
      "kind": "LinkedField",
      "name": "square",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "light"
        },
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "transparent"
        }
      ]
    }
  ]
},
v32 = {
  "kind": "ScalarField",
  "name": "key"
},
v33 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v34 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v35 = {
  "kind": "ScalarField",
  "name": "description"
},
v36 = {
  "kind": "ScalarField",
  "name": "watcherCount"
},
v37 = {
  "kind": "ScalarField",
  "name": "summary"
},
v38 = [
  (v32/*: any*/),
  (v29/*: any*/),
  (v17/*: any*/)
],
v39 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v27/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/)
    ]
  },
  (v24/*: any*/),
  (v17/*: any*/)
],
v40 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v41 = {
  "kind": "ScalarField",
  "name": "label"
},
v42 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v43 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v42/*: any*/)
},
v44 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v45 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  (v41/*: any*/),
  (v43/*: any*/),
  {
    "alias": "tooltip",
    "args": (v44/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v44/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v42/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v46 = {
  "alias": "projectStateValue",
  "kind": "ScalarField",
  "name": "value"
},
v47 = {
  "concreteType": "CompletionProjectState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "value"
    },
    (v41/*: any*/),
    (v43/*: any*/)
  ]
},
v48 = {
  "kind": "ScalarField",
  "name": "title"
},
v49 = [
  {
    "kind": "ScalarField",
    "name": "active"
  },
  {
    "kind": "ScalarField",
    "name": "missed"
  },
  {
    "kind": "ScalarField",
    "name": "atRisk"
  },
  {
    "kind": "ScalarField",
    "name": "onTrack"
  },
  {
    "kind": "ScalarField",
    "name": "offTrack"
  },
  {
    "kind": "ScalarField",
    "name": "done"
  },
  {
    "kind": "ScalarField",
    "name": "cancelled"
  }
],
v50 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v51 = {
  "kind": "Literal",
  "name": "sort",
  "value": [
    "NAME_ASC"
  ]
},
v52 = [
  (v16/*: any*/),
  {
    "concreteType": "ProjectEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v32/*: any*/),
          (v27/*: any*/),
          (v23/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "concreteType": "UserPII",
                "kind": "LinkedField",
                "name": "pii",
                "plural": false,
                "selections": [
                  (v25/*: any*/),
                  (v26/*: any*/)
                ]
              },
              (v17/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectUpdatesViewQuery",
    "selections": [
      {
        "args": [
          (v10/*: any*/),
          {
            "kind": "Variable",
            "name": "prevDate",
            "variableName": "prevDate"
          },
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ProjectUpdatesMainColumn"
      },
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "completedProjectsTqlQuery",
                "variableName": "completedProjectsTqlQuery"
              },
              {
                "kind": "Variable",
                "name": "newProjectsTqlQuery",
                "variableName": "newProjectsTqlQuery"
              },
              {
                "kind": "Variable",
                "name": "ownProjectsTqlQuery",
                "variableName": "ownProjectsTqlQuery"
              },
              (v15/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProjectUpdatesSideColumn"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectUpdatesViewQuery",
    "selections": [
      {
        "alias": "userWatchingNotContributing",
        "args": [
          (v13/*: any*/)
        ],
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": "EXCLUDE_CONTRIBUTING_PROJECTS"
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              },
              (v13/*: any*/)
            ],
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "watching",
            "plural": false,
            "selections": [
              (v16/*: any*/)
            ]
          },
          (v17/*: any*/)
        ]
      },
      {
        "args": (v20/*: any*/),
        "kind": "ScalarField",
        "name": "allWatchedProjectUpdatesCount"
      },
      {
        "args": (v21/*: any*/),
        "concreteType": "UpdateConnection",
        "kind": "LinkedField",
        "name": "allWatchedProjectUpdates",
        "plural": false,
        "selections": [
          {
            "concreteType": "UpdateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "missedUpdate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "updateType"
                      },
                      (v17/*: any*/),
                      (v23/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v24/*: any*/),
                          (v17/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "Project",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          (v23/*: any*/),
                          {
                            "concreteType": "Workspace",
                            "kind": "LinkedField",
                            "name": "workspace",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/),
                              (v17/*: any*/)
                            ]
                          },
                          (v17/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "watching"
                          },
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v27/*: any*/),
                          {
                            "concreteType": "ProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v33/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "latestUpdateDate"
                          },
                          {
                            "args": (v34/*: any*/),
                            "concreteType": "TagConnection",
                            "kind": "LinkedField",
                            "name": "tagsWatchedByUser",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TagEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Tag",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v27/*: any*/),
                                      (v23/*: any*/),
                                      (v35/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "projectUsageCount"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "goalUsageCount"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "helpPointerUsageCount"
                                      },
                                      (v36/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "tagsWatchedByUser(first:3)"
                          },
                          {
                            "args": (v34/*: any*/),
                            "concreteType": "TeamConnection",
                            "kind": "LinkedField",
                            "name": "teamsWatchedByUser",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TeamEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Team",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v27/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "teamId"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "teamsWatchedByUser(first:3)"
                          }
                        ]
                      },
                      (v29/*: any*/),
                      (v33/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "concreteType": "ProjectChangelogItem",
                        "kind": "LinkedField",
                        "name": "changelog",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "newValue"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "oldValue"
                          },
                          (v17/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "LearningConnection",
                        "kind": "LinkedField",
                        "name": "learnings",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "LearningEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Learning",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "type"
                                  },
                                  (v23/*: any*/),
                                  (v17/*: any*/),
                                  (v37/*: any*/),
                                  (v35/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v29/*: any*/),
                                      {
                                        "concreteType": "Project",
                                        "kind": "LinkedField",
                                        "name": "project",
                                        "plural": false,
                                        "selections": (v38/*: any*/)
                                      },
                                      {
                                        "concreteType": "Goal",
                                        "kind": "LinkedField",
                                        "name": "goal",
                                        "plural": false,
                                        "selections": (v38/*: any*/)
                                      },
                                      {
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "creator",
                                        "plural": false,
                                        "selections": (v39/*: any*/)
                                      },
                                      (v33/*: any*/),
                                      {
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "lastEditedBy",
                                        "plural": false,
                                        "selections": (v39/*: any*/)
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "lastEditedDate"
                                      }
                                    ],
                                    "type": "Highlight",
                                    "abstractKey": "__isHighlight"
                                  }
                                ]
                              }
                            ]
                          },
                          (v16/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "CommentConnection",
                        "kind": "LinkedField",
                        "name": "comments",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v40/*: any*/),
                                  (v29/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "commentText"
                                  },
                                  (v33/*: any*/),
                                  {
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "creator",
                                    "plural": false,
                                    "selections": [
                                      (v24/*: any*/),
                                      {
                                        "concreteType": "UserPII",
                                        "kind": "LinkedField",
                                        "name": "pii",
                                        "plural": false,
                                        "selections": [
                                          (v25/*: any*/),
                                          (v27/*: any*/),
                                          (v28/*: any*/),
                                          (v26/*: any*/)
                                        ]
                                      },
                                      (v17/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__id"
                              }
                            ]
                          }
                        ]
                      },
                      (v40/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v24/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v27/*: any*/)
                            ]
                          },
                          (v17/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v45/*: any*/)
                      },
                      {
                        "concreteType": "ProjectState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": [
                          (v46/*: any*/),
                          (v41/*: any*/),
                          (v43/*: any*/),
                          (v47/*: any*/)
                        ]
                      },
                      (v37/*: any*/),
                      {
                        "concreteType": "UpdateNote",
                        "kind": "LinkedField",
                        "name": "notes",
                        "plural": true,
                        "selections": [
                          (v23/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "archived"
                          },
                          (v48/*: any*/),
                          (v37/*: any*/),
                          (v17/*: any*/),
                          (v22/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v45/*: any*/)
                      },
                      {
                        "concreteType": "ProjectState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": [
                          (v41/*: any*/),
                          (v43/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "MilestoneConnection",
                        "kind": "LinkedField",
                        "name": "milestones",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MilestoneEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Milestone",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  (v17/*: any*/),
                                  (v48/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "targetDate"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "targetDateType"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "status"
                                  }
                                ]
                              }
                            ]
                          },
                          (v16/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              },
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v32/*: any*/),
                                  (v17/*: any*/)
                                ]
                              }
                            ],
                            "type": "GoalUpdate"
                          }
                        ],
                        "type": "Update",
                        "abstractKey": "__isUpdate"
                      }
                    ],
                    "type": "ProjectUpdate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v21/*: any*/),
        "filters": [
          "workspaceId",
          "createdBefore",
          "createdAfter",
          "stateFilter"
        ],
        "handle": "connection",
        "key": "ProjectUpdatesList_allWatchedProjectUpdates",
        "kind": "LinkedHandle",
        "name": "allWatchedProjectUpdates"
      },
      {
        "alias": "currentSummary",
        "args": [
          (v10/*: any*/),
          (v11/*: any*/),
          (v13/*: any*/)
        ],
        "concreteType": "StatusSummary",
        "kind": "LinkedField",
        "name": "projectStatusSummary",
        "plural": false,
        "selections": (v49/*: any*/)
      },
      {
        "alias": "previousSummary",
        "args": [
          {
            "kind": "Variable",
            "name": "endDate",
            "variableName": "startDate"
          },
          {
            "kind": "Variable",
            "name": "startDate",
            "variableName": "prevDate"
          },
          (v13/*: any*/)
        ],
        "concreteType": "StatusSummary",
        "kind": "LinkedField",
        "name": "projectStatusSummary",
        "plural": false,
        "selections": (v49/*: any*/)
      },
      {
        "alias": "allProjectUpdatesCount",
        "args": (v20/*: any*/),
        "kind": "ScalarField",
        "name": "allWatchedProjectUpdatesCount"
      },
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "ownProjects",
            "args": [
              (v50/*: any*/),
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "ownProjectsTqlQuery"
              },
              (v51/*: any*/),
              (v15/*: any*/)
            ],
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "projectTql",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "concreteType": "ProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Project",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v32/*: any*/),
                      (v27/*: any*/),
                      (v23/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v36/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "newProjects",
            "args": [
              (v50/*: any*/),
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "newProjectsTqlQuery"
              },
              {
                "kind": "Literal",
                "name": "sort",
                "value": [
                  "CREATION_DATE_DESC"
                ]
              },
              (v15/*: any*/)
            ],
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "projectTql",
            "plural": false,
            "selections": (v52/*: any*/)
          },
          {
            "alias": "completedProjects",
            "args": [
              (v50/*: any*/),
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "completedProjectsTqlQuery"
              },
              (v51/*: any*/),
              (v15/*: any*/)
            ],
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "projectTql",
            "plural": false,
            "selections": (v52/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ac9132fae7eb1ab6e9f4b1be76429508",
    "id": null,
    "metadata": {},
    "name": "ProjectUpdatesViewQuery",
    "operationKind": "query",
    "text": "query ProjectUpdatesViewQuery(\n  $prevDate: DateTime\n  $startDate: DateTime\n  $endDate: DateTime\n  $workspaceId: ID\n  $workspaceUUID: UUID!\n  $stateFilter: UpdateStateFilter\n  $ownProjectsTqlQuery: String!\n  $newProjectsTqlQuery: String!\n  $completedProjectsTqlQuery: String!\n  $isNavRefreshEnabled: Boolean!\n) {\n  ...ProjectUpdatesMainColumn_352XcS\n  ...ProjectUpdatesSideColumn_2H0l1v @skip(if: $isNavRefreshEnabled)\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment InsertKudosInFeed on UpdateConnection {\n  edges {\n    node {\n      __typename\n      ... on ProjectUpdate {\n        missedUpdate\n        updateType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment LearningCard_cardQuery on Learning {\n  uuid\n  id\n  summary\n  description\n  type\n  ...LearningModifierSignatures_data\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningsSummary_data on ProjectUpdate {\n  learnings {\n    edges {\n      node {\n        type\n        ...LearningCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MilestoneCard_cardQuery on Milestone {\n  uuid\n  ...MilestoneFields\n}\n\nfragment MilestoneFields on Milestone {\n  id\n  title\n  targetDate\n  targetDateType\n  status\n}\n\nfragment MilestonesSummary_data on ProjectUpdate {\n  milestones {\n    edges {\n      node {\n        ...MilestoneCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MissedProjectUpdateCard on ProjectUpdate {\n  id\n  uuid\n  project {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop_PTxnb\n  ...ProjectUpdateTargetDateAutoUpdated\n  ...LearningsSummary_data\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment ProjectDateChanged on ProjectUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment ProjectFollowButton on Project {\n  id\n  uuid\n  watching\n}\n\nfragment ProjectFollowersButton on Project {\n  key\n  watcherCount\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectMissedUpdateLabel on ProjectUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  project {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectRowWithFollowers on Project {\n  key\n  ...ProjectName_data\n  ...ProjectFollowersButton\n}\n\nfragment ProjectRowWithOwner_4yoa7g on Project {\n  key\n  ...ProjectName_data\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  projectStateValue: value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectStatusChanged on ProjectUpdate {\n  newState {\n    ...ProjectState\n  }\n  oldState {\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateCardByline on Project {\n  watching\n  tagsWatchedByUser(first: 3) {\n    edges {\n      node {\n        ...Tag\n        id\n      }\n    }\n  }\n  teamsWatchedByUser(first: 3) {\n    edges {\n      node {\n        id\n        name\n        teamId\n      }\n    }\n  }\n}\n\nfragment ProjectUpdateCardContentExtras on ProjectUpdate {\n  ...ProjectUpdateNotes\n  ...ProjectUpdateDiff\n  ...LearningsSummary_data\n  ...MilestonesSummary_data\n  ...ProjectUpdateTargetDateAutoUpdated\n}\n\nfragment ProjectUpdateCardFooter on ProjectUpdate {\n  ari\n  updateType\n  missedUpdate\n  project {\n    ari\n    ...ProjectFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment ProjectUpdateCardHeader on ProjectUpdate {\n  project {\n    ...ProjectFollowButton\n    ...ProjectIcon\n    id\n    key\n    name\n  }\n}\n\nfragment ProjectUpdateCardInternal on ProjectUpdate {\n  id\n  project {\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop\n  ...ProjectUpdateSummary\n  ...ProjectUpdateCardContentExtras\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment ProjectUpdateCardTop on ProjectUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...ProjectUpdateCreationDate\n  ...ProjectUpdateStatus\n  ...ProjectMissedUpdateLabel\n}\n\nfragment ProjectUpdateCardTop_PTxnb on ProjectUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...ProjectMissedUpdateLabel\n  missedUpdate\n}\n\nfragment ProjectUpdateCard_3UosK1 on ProjectUpdate {\n  id\n  uuid\n  missedUpdate\n  updateType\n  creator {\n    aaid\n    id\n  }\n  ...MissedProjectUpdateCard\n  ...ProjectUpdateCardInternal\n  project {\n    uuid\n    ...ProjectUpdateCardByline\n    id\n  }\n  milestones {\n    count\n  }\n  learnings {\n    count\n  }\n  notes {\n    __typename\n    id\n  }\n}\n\nfragment ProjectUpdateCreationDate on ProjectUpdate {\n  id\n  project {\n    key\n    id\n  }\n  creationDate\n  editDate\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n}\n\nfragment ProjectUpdateDiff on ProjectUpdate {\n  ...ProjectDateChanged\n  ...ProjectStatusChanged\n}\n\nfragment ProjectUpdateNotes on ProjectUpdate {\n  notes {\n    uuid\n    ...UpdateNote\n    id\n  }\n}\n\nfragment ProjectUpdateStatus on ProjectUpdate {\n  newDueDate {\n    ...TargetDate\n  }\n  newState {\n    projectStateValue: value\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateSummary on ProjectUpdate {\n  summary\n}\n\nfragment ProjectUpdateTargetDateAutoUpdated on ProjectUpdate {\n  project {\n    key\n    id\n  }\n  newTargetDate\n  changelog {\n    newValue\n    oldValue\n    id\n  }\n}\n\nfragment ProjectUpdatesFeed_352XcS on Query {\n  ...ProjectUpdatesList_1j3MN4\n  ...ProjectUpdatesStatusSummary_2oYDyA\n  currentSummary: projectStatusSummary(startDate: $startDate, endDate: $endDate, workspaceId: $workspaceId) {\n    missed\n  }\n  allProjectUpdatesCount: allWatchedProjectUpdatesCount(workspaceUUID: $workspaceUUID, stateFilter: ACTIVE, createdAfter: $startDate, createdBefore: $endDate)\n}\n\nfragment ProjectUpdatesList_1j3MN4 on Query {\n  allWatchedProjectUpdates(workspaceId: $workspaceId, first: 10, createdBefore: $endDate, createdAfter: $startDate, stateFilter: $stateFilter) {\n    ...InsertKudosInFeed\n    edges {\n      node {\n        __typename\n        ...ProjectUpdateCard_3UosK1\n        ... on ProjectUpdate {\n          id\n          project {\n            id\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ProjectUpdatesMainColumn_352XcS on Query {\n  userWatchingNotContributing: currentUser(workspaceId: $workspaceId) {\n    watching(workspaceId: $workspaceId, first: 1, filter: EXCLUDE_CONTRIBUTING_PROJECTS) {\n      count\n    }\n    id\n  }\n  allWatchedProjectUpdatesCount(workspaceUUID: $workspaceUUID, stateFilter: ACTIVE, createdAfter: $startDate, createdBefore: $endDate)\n  ...ProjectUpdatesFeed_352XcS\n}\n\nfragment ProjectUpdatesSideColumn_2H0l1v on Query {\n  ownProjects: projectTql(first: 20, workspaceUuid: $workspaceUUID, q: $ownProjectsTqlQuery, sort: [NAME_ASC]) {\n    ...ProjectWithFollowersSidebarSection\n  }\n  newProjects: projectTql(first: 20, workspaceUuid: $workspaceUUID, q: $newProjectsTqlQuery, sort: [CREATION_DATE_DESC]) {\n    ...ProjectWithOwnerSidebarSection\n  }\n  completedProjects: projectTql(first: 20, workspaceUuid: $workspaceUUID, q: $completedProjectsTqlQuery, sort: [NAME_ASC]) {\n    ...ProjectWithOwnerSidebarSection\n  }\n}\n\nfragment ProjectUpdatesStatusSummary_2oYDyA on Query {\n  currentSummary: projectStatusSummary(startDate: $startDate, endDate: $endDate, workspaceId: $workspaceId) {\n    active\n    missed\n    atRisk\n    onTrack\n    offTrack\n    done\n    cancelled\n  }\n  previousSummary: projectStatusSummary(startDate: $prevDate, endDate: $startDate, workspaceId: $workspaceId) {\n    active\n    missed\n    atRisk\n    onTrack\n    offTrack\n    done\n    cancelled\n  }\n}\n\nfragment ProjectWithFollowersSidebarSection on ProjectConnection {\n  count\n  edges {\n    node {\n      id\n      ...ProjectRowWithFollowers\n    }\n  }\n}\n\nfragment ProjectWithOwnerSidebarSection on ProjectConnection {\n  count\n  edges {\n    node {\n      id\n      ...ProjectRowWithOwner_4yoa7g\n    }\n  }\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment Tag on Tag {\n  ...Tag_createTagOption\n}\n\nfragment Tag_createTagOption on Tag {\n  id\n  name\n  uuid\n  description\n  projectUsageCount\n  goalUsageCount\n  helpPointerUsageCount\n  watcherCount\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n"
  }
};
})();

(node as any).hash = "cf2c4c3a38aa8d0154fa671767e2bb2b";

export default node;
